import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { farmsRoute } from '~/routes'
import { updateRecord, findRecord, clearState } from '~/store/modules/farms';
import FarmRecord from '~/records/FarmRecord';
import CrudEdit from '~/containers/CrudEdit';

import FormFields from './components/FormFields';

export default function Edit() {
  const [record, setRecord] = useState(new FarmRecord());
  const dispatch = useDispatch();
  const { isLoading, current, errors } = useSelector(state => state.farms);
  const { id } = useParams();

  useEffect(() => {
    dispatch( findRecord(id) );
    return () => {
      dispatch( clearState() )
    };
  }, [])

  useEffect(() => {
    if(current){
      setRecord( record.updateAttributes(current) )
    }
  }, [current])

  const onSubmit = useCallback( () => {
    const data = record.toParams();
    dispatch( updateRecord(id, data) );
  }, [record, id]);

  const handleChange = useCallback(attrs => {
    setRecord(record.updateAttributes(attrs));
  }, [record, setRecord]);

  return (
    <CrudEdit
      isLoading={isLoading}
      onSubmit={onSubmit}
      errors={{ errors }}
      breadcrumbs={[
        { path: farmsRoute.list.path, text: 'Fazendas' },
        { text: 'Editando Fazenda' },
      ]}
      footerActionsProps={{isLoading, showSaveAndContinue: false}}
    >
      <FormFields
        record={record}
        onChange={handleChange}
      />
    </CrudEdit>
  );
}